import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlus,
  faSort,
  faEllipsisVertical,
  faTrash,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import clientDemoImg from "../assets/img/EmptyLogo.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import { commonAPI } from "../services/CommonAPIService";
import Menus from "./menus";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
// import SlideButton from "react-slide-button";
import { Stepper, Step, StepLabel } from "@mui/material";
// import  clientimg  from '../assets/img/clientimg.jpg';
// import  clientimg2  from '../assets/img/clientimg-2.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import INDFlag from "../assets/img/INDFlag.jpg";
import { ErrorSource } from "../common/constants";
import { faCopy, faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
 import switchBaseClasses from "@mui/material/internal/switchBaseClasses";
 import { styled } from '@mui/material/styles';
 import FormGroup from '@mui/material/FormGroup';
 import FormControlLabel from '@mui/material/FormControlLabel';
 import Switch, { SwitchProps } from '@mui/material/Switch';
 import Table from 'react-bootstrap/Table'; 
 import Stack from '@mui/material/Stack';
 import Typography from '@mui/material/Typography';


function ApplicationSettings() {
  const [BuildingList, setBuildingList] = useState("");
  const [BuildingId, setBuildingId] = useState("");
  const [BuildingCopyList, setBuildingCopyList] = useState("");
  const [BuildingCopyId, setBuildingCopyId] = useState("");
  const [show, setShow] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [AppSettingList, setAppSettingList] = useState("");
  const [AppSettingSource, setAppSettingSource] = useState("");
  const [Key, setKey] = useState("");
  const [Value, setValue] = useState("");
  const [IsEditable, setIsEditable] = useState(true);
  const [IsRender, setIsRender] = useState(true);
  const [IsActive, setIsActive] = useState(true);
  const [AppSettingId, setAppSettingId] = useState("");
  const [UpdateBtn, setUpdateBtn] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [slideshowHeight, setSlideshowHeight] = useState(0);
  console.log(selectedItems , "selectedItems")

  const updateSlideshowHeight = () => {
      const winHeight = window.innerHeight; // Get the window height
      setSlideshowHeight(winHeight - 270); // Set the slideshow height
    };
      
    useEffect(() => {
        updateSlideshowHeight();
        window.addEventListener('resize', updateSlideshowHeight);
    
        return () => {
            window.removeEventListener('resize', updateSlideshowHeight);
        };
    }, []);
  


  useEffect(() => {        
    (async function(){
        const BuildingAuth = localStorage.getItem("BuildingId");
        const myBuildingId = JSON?.parse(BuildingAuth);
        console.log("myBuildingId", myBuildingId)
        setBuildingId(myBuildingId);
    })()
  }, [])

  useEffect(() => {
    if(BuildingId){
        (async function(){
            await localStorage.setItem("BuildingId", BuildingId?.toString());
        })()

      // GetTowerList();
      
      }else if (BuildingId == ""){
          // setTowerList("");
          setAppSettingList("")
      }
  }, [BuildingId])

  const GetBuildingList = async () => {
    const auth = localStorage.getItem("primeProductCode");
    const ProductfactorKey = JSON.parse(auth);
    const endPointVariableKey = {
        ProductId: ProductfactorKey?.primeProductCode,
    }
    try {
        // setLoading(true);
        let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
        if (response?.success===true){
          console.log("BuildingLite", response)
            setBuildingList(response?.data);
            
            // setLoading(false);
        }else{
            toast.error("Something went wrong");
            // setLoading(false);
        }

    } catch (error) {
        console.log(error);
        // setLoading(false);
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyError = JSON.stringify({ 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": null,
            "uri": "/api/Common/Building",
            "errorNumber": "GB01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "tower.js",
            "functionName": "GetBuildingList",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            // setLoading(false);
        } else {
            // setLoading(false);
            toast.error("Something went wrong");
        }
    }

  }

  const GetBuildingListShort = async () => {
    if(BuildingList){
      const updatedUsers = BuildingList?.filter(user => user?.buildingId != BuildingId);
      console.log("updatedUsers", updatedUsers)
      setBuildingCopyList(updatedUsers)
      // return
    }  
  }

  const GetApplicationSettingList = async () => {
    const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
    try {
      setLoading(true);
      const endPointVariableKey = {
          urlVariable: null,
          buildingId: BuildingId
      }
      let response = await commonAPI("AppSettings", undefined, endPointVariableKey);
      console.log("AppSettings", response);
      if (response?.success === true) {
        setAppSettingList(response?.data);
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);

      setLoading(false);
      const bodyError = {
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "/api/Master/AppSettings",
        errorNumber: "AS01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "ApplicationSettings.js",
        functionName: "GetApplicationSettingList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetApplicationSettingSource = async () => {
    const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
    try {
      setLoading(true);
      const endPointVariableKey = {
          urlVariable: null,
          buildingId: BuildingCopyId
      }
      let response = await commonAPI("AppSettings", undefined, endPointVariableKey);
      console.log("AppSettings", response);
      if (response?.success === true) {
        setAppSettingSource(response?.data);
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);

      setLoading(false);
      const bodyError = {
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "/api/Master/AppSettings",
        errorNumber: "AS01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "ApplicationSettings.js",
        functionName: "GetApplicationSettingList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

    useEffect(() => {
      GetBuildingList();
      
    }, [])

    useEffect(() => {
      if(BuildingId){
        GetApplicationSettingList();
      }  
    }, [BuildingId])

    useEffect(() => {
      if(BuildingCopyId){
        GetApplicationSettingSource();
      }else{
        setAppSettingSource("")
      }
    }, [BuildingCopyId])

    useEffect(() => {
      setTimeout(GetBuildingListShort, 1000)
      // GetBuildingListShort();
    }, [BuildingList, BuildingId])

    const ClearValue = () => {
      setKey("")
      setValue("")
      setIsRender(true)
      setIsActive(true)
      setIsEditable(true)
      setAppSettingId("")
      setUpdateBtn(false)
    }

  const UpdateValue = (item) => {
      console.log("item", item)
      setKey(item?.key)
      setValue(item?.value)
      setIsRender(item?.isRender)
      setIsActive(item?.isActive)
      setIsEditable(item?.isEditable)
      setAppSettingId(item?.appSettingId)
      setUpdateBtn(true)
  }

  const AppSettingUpdate = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyData =
    {
      "appSettingId": AppSettingId,
      "key": Key,
      "value": Value,
      "isEditable": IsEditable == "true" || IsEditable == true ? true : false,
      "isRender": IsRender == "true" || IsRender == true ? true : false,
      "isActive": IsActive  == "true" || IsActive == true ? true : false,
      "modifiedUserId": myUserData?.userId?.toString()
    }
    try {
        setLoading(true);
        if(!BuildingId){
          toast.warning("Please select Building"); 
          setLoading(false);
      }else if(!Key){
            toast.warning("Please enter key"); 
            setLoading(false);
        }else if(!Value){
            toast.warning("Please enter value");     
            setLoading(false);
        
        }else{
            const endPointVariableKey = {
                buildingId: BuildingId
            }
            let response = await commonAPI("AppSettingsUpdate", bodyData, endPointVariableKey)
            setLoading(true);
            console.log("RFIDTag Update response", response, bodyData);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Application settings updated");
                GetApplicationSettingList();
                setKey("")
                setValue("")
                setIsRender(true)
                setIsActive(true)
                setIsEditable(true)
                setUpdateBtn(false)
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
                GetApplicationSettingList()
            }   
        }
    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/Master/ApplicationSetting",
            "errorNumber": "TA01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "ApplicationSettings.js",
            "functionName": "AppSettingUpdate",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }   
  }

  const AppSettingAdd = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyData =
    {
      "key": Key,
      "value": Value,
      "isEditable": IsEditable == "true" || IsEditable == true ? true : false,
      "isRender": IsRender == "true" || IsRender == true ? true : false,
      "isActive": IsActive  == "true" || IsActive == true ? true : false,
      "createdUserId": myUserData?.userId?.toString()
    }
    try {
        setLoading(true);
        if(!BuildingId){
            toast.warning("Please select Building"); 
            setLoading(false);
        }else if(!Key){
            toast.warning("Please enter key"); 
            setLoading(false);
        }else if(!Value){
            toast.warning("Please enter value");     
            setLoading(false);
        }else if(!IsEditable){
            toast.warning("Please select Editable");  
            setLoading(false);
          }else if(!IsRender){
            toast.warning("Please select Render");             
            setLoading(false);    
        }else if(!IsActive){
            toast.warning("Please select Active");             
            setLoading(false);
        }else{
            const endPointVariableKey = {
                buildingId: BuildingId
            }
            let response = await commonAPI("AppSettingsAdd", bodyData, endPointVariableKey)
            setLoading(true);
            console.log("AppSettingsAdd response", response, bodyData);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Application settings added");
                GetApplicationSettingList();
                setKey("")
                setValue("")
                setIsRender(true)
                setIsActive(true)
                setIsEditable(true)
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }   
        }
    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/Master/ApplicationSetting",
            "errorNumber": "TA01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "ApplicationSettings.js",
            "functionName": "AppSettingAdd",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }   
  }

  const AppSettingCopy = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const ArryTStr = selectedItems.join()
    const bodyData =
    {
      "sourceBuildingId": parseInt(BuildingCopyId),
      "AppSettingIdList": ArryTStr,
      "createdUserId": myUserData?.userId?.toString()
    }
    try {
        setLoading(true);
        if(!BuildingCopyId){
            toast.warning("Please select Source Building"); 
            setLoading(false);
        }else if(!selectedItems){
            toast.warning("Please enter App Setting");     
            setLoading(false);
        }else{
            const endPointVariableKey = {
                buildingId: BuildingId
            }
            let response = await commonAPI("AppSettingsCopy", bodyData, endPointVariableKey)
            setLoading(true);
            console.log("AppSettingsCopy response", response, bodyData);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Application Settings Copied");
                GetApplicationSettingList();
                setShow(false)
                setSelectedItems([])
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }   
        }
    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/Master/AppSettingsCopy",
            "errorNumber": "ASC01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "ApplicationSettings.js",
            "functionName": "AppSettingCopy",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }   
  }

  const handleCheckboxChange = (item) => {
    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.includes(item)) {
        // Remove item if it is already selected
        return prevSelectedItems.filter((selectedItems) => selectedItems !== item);
      } else {
        // Add item if it is not selected
        return [...prevSelectedItems, item];
      }
    });
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedItems([]); // Deselect all items
    } else {
      setSelectedItems(AppSettingList.map((item) => item?.appSettingId)); // Select all items
    }
    setSelectAll(!selectAll); // Toggle the selectAll state
  };

  return (
    <>
    {Loading? 
      <div className="loaderDiv">
          <div className="loader"></div>
      </div> 
    :null}
    <ToastContainer />
    <style>
        {`.table-responsive {
            height: ${slideshowHeight}px;
            overflow-y: auto;
            background-color: #f8f9fa;
        }`}
    </style>
    <div className="container-fluid">
       <div className="row mb-0" style={{ alignItems:'center', marginTop: 95 }}>
        <div className="col-lg-6 col-md-6 px-0">
          <div className="HeadingTop">
            <h3> Application Settings </h3>
            <span> Customize and modify application settings to optimize the user experience.</span>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 px-0 text-right">
            <select  name="taskTypes" style={{width:"140px"}} value={BuildingId}  className="sltareamodal col-6 ml-auto bg-white" onChange={(e) => {
                    console.log("selection", e.target.value)
                    setBuildingId(e.target.value);}}>
            <option value="">Select Building</option>
            {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}  >{item?.buildingName}</option>): null}
          </select>
          <Button className="mb-3 mb-md-0 createClr" onClick={() => {
            if(BuildingId){
              setShow(true); setSelectedItems([]); setBuildingCopyId(""); setAppSettingSource("")
            }else{
              toast.warning("Please select Building");
            }  
            
            }}>Copy Settings</Button>
 
        </div>
      </div>
</div>
<div className="container-fluid">
      <div className="row">
        <div className="tableFixHead">
          <div className="scrolling_tbl" style={{height: "auto", overflow: "hidden"}}>
            <Table striped responsive className="mb-0">
              <thead>
                <tr>
                  
                  <th>Key</th>
                  <th>Value</th>
                  <th>Editable ?</th>
                  <th>Render ?</th>
                  <th>Active ?</th>
                  <th>Action ?</th>
                  {/* <th>Delete</th> */}
                </tr>
              </thead>
              <tbody>
                {AppSettingList ? AppSettingList?.map((item, index) => 
                  <tr>
                    <td>{item?.key}</td>
                    <td>{item?.value}</td>
                    <td>{item?.isEditable == true ? "Yes" : "No"}</td>
                    <td>{item?.isRender == true ? "Yes" : "No"}</td>
                    <td>{item?.isActive == true ? "Yes" : "No"}</td>
                    <td><FontAwesomeIcon className="deleteNotice" icon={faEdit} onClick={() => UpdateValue(item, index)} /></td>
                  </tr>
                ): null}
              </tbody>
              <tfoot>
                  <tr>
                      <th><input type="text" value={Key} onChange={(e) => setKey(e.target.value)}  placeholder="Key" className="footbtn" /></th>
                      <th><input type="text" value={Value} onChange={(e) => setValue(e.target.value)}  placeholder="Value" className="footbtn"  /></th>
                      <th>
                          <select name="cars" className="footbtn" value={IsEditable} onChange={(e) => setIsEditable(e.target.value)} style={{width: 80}} >
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                      </th>
                      {/* <th><input type="text" value={IsEditable} onChange={(e) => setIsEditable(e.target.value)} placeholder="Editable ?" className="footbtn"  /></th> */}
                      <th>
                        <select name="cars" className="footbtn" value={IsRender} onChange={(e) => setIsRender(e.target.value)} style={{width: 80}}>
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </th>  
                      <th>
                        <select name="cars" className="footbtn" value={IsActive} onChange={(e) => setIsActive(e.target.value)} style={{width: 80}}>
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </th>
                      <th className="sn">
                          {!UpdateBtn ? 
                              <div className="row mt-2" style={{display: "inline"}}>
                                  <Button  className="btn border bg-secondary text-white col-6 pl-0 pr-0" onClick={ClearValue}>
                                      Cancel
                                  </Button>
                                  <Button onClick={() =>
                                      AppSettingAdd()} className="createClr w-100 col-6">
                                      Save
                                  </Button>
                              </div>    
                              :
                              <div className="row mt-2" style={{display: "inline"}}>
                                  <Button onClick={ClearValue} className="btn border bg-secondary text-white col-6 pl-0 pr-0">
                                      Cancel
                                  </Button>
                                  <Button onClick={() =>
                                      AppSettingUpdate()} className="createClr w-100 col-6 pl-0 pr-0">
                                      {" "}
                                      Update
                                  </Button>
                              </div>    
                          }
                          {" "} 
                      </th>
                  </tr>
              </tfoot>

            </Table>
          </div>
        </div> 

        <Modal size="lg" show={show} onHide={() =>
                [setShow(false), ]} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                      <div  style={{width:"757px"}}>
                        <Modal.Header closeButton className='headerMDL'>
                            <Modal.Title id="contained-modal-title-vcenter">
                              Application Settings
                                {/* {UpdateTowerBtn ?   <>Update Tower</> : <>Add  Tower</> } */}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="helpingElelemnt_uuy002" style={{width: "100%"}}>

          
                      <div className="row" id="validation">
                    <div className="col-12">
                       
                            <div className="card-body p-0">
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                        <select  name="taskTypes" style={{width:"140px"}} value={BuildingCopyId}  className="sltareamodal col-6 ml-auto bg-white" onChange={(e) => {
                                                  console.log("selection", e.target.value)
                                                  setBuildingCopyId(e.target.value);}}>
                                          <option value="">Select Building</option>
                                          {BuildingCopyList ? BuildingCopyList?.map((item, index) =>  <option key={index} value={item?.buildingId}  >{item?.buildingName}</option>): null}
                                        </select>
                                    
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                        <div className="row text-left">
                                          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                          <div className="tableFixHead">
                                            <div className="scrolling_tbl" style={{height: "auto", overflow: "hidden"}}>
                                              <Table striped responsive className="mb-0">
                                                <thead>
                                                  <tr>
                                                  <th style={{whiteSpace: "nowrap", }}>Select all <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked={selectAll} onChange={handleSelectAllChange} style={{position: "relative", left: 7, opacity: 1, top: 2}} /></th>
                                                    <th>Key</th>
                                                    <th >Value</th>
                                                    {/* <th>Editable ?</th>
                                                    <th>Render ?</th>
                                                    <th>Active ?</th> */}
                                                  
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                {AppSettingSource ? AppSettingSource?.map((item, index) => 
                                                  <tr>
                                                    <td ><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked={selectedItems.includes(item?.appSettingId)} onChange={() => handleCheckboxChange(item?.appSettingId)} style={{position: "relative", left: 0, opacity: 1}} /></td>
                                                    <td> {item?.key}</td>
                                                    {/* <td>{item?.value}</td> */}
                                                    <td className="vlu">{item?.value}  </td>
                                                    {/* <td>{item?.isEditable == true ? "Yes" : "No"}</td>
                                                    <td>{item?.isRender == true ? "Yes" : "No"}</td>
                                                    <td>{item?.isActive == true ? "Yes" : "No"}</td> */}
                                                  </tr>
                                                ): null}
                                                  
                                                </tbody>

                                              </Table>
                                            </div>
                                          </div>    
                                            
                                          </div>

                                        </div>  
                                    </section>
 
                                </div>
                                

                                    </form>

                            </div>

                    </div>

                </div>

        </Modal.Body>
        
        <div className="fixed_allbtn">                        
                        <div className="upload_btn">
                        <ul role="menu" aria-label="Pagination" className='mb-0'>
                          <div className="  align-self-start">
                              <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                              <button type="button" className="btn btn-info" onClick={AppSettingCopy}> Copy</button>
                          </div>  
                        </ul>
                  </div>
          </div>
          </div> 



      </Modal>

      </div>
</div>

      
</>
  );
}
export default ApplicationSettings;
